import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import NoProductImg from '../../../../assets/images/NoProduct2.png';
import ConfigApi from '../../../../configs/ConfigApi';
import { useAuth } from '../../../contexts/AuthProvider';
import AxiosAuth from '../../../utils/AxiosAuth';
import InitInfo from '../../../utils/InitInfo';
import UserReviewSection from '../components/UserReviewSection';
import UserReviewSectionComplete from '../components/UserReviewSectionComplete';

function UserReviewTitleBar({ type }) {
    return (
        <div className="user-wish-title">
            <div className="user-wish-title-view">
                <Link
                    to="/user/reviews/"
                    className={type === 'pending' ? 'user-wish-btn-active' : ''}
                >
                    To Be Reviewed
                </Link>
                <Link
                    to="/user/reviews/history/"
                    className={type === 'complete' ? 'user-wish-btn-active' : ''}
                >
                    Review History
                </Link>
            </div>
        </div>
    );
}

function UserReviewPage({ type }) {
    const { currentUser } = useAuth();
    const { products } = InitInfo();

    const [memoAr, setMemoAr] = useState([]);
    const [memoItemAr, setMemoItemAr] = useState([]);

    useEffect(() => {
        AxiosAuth.currentUserAuth(currentUser)
            .get(ConfigApi.API_USER_REVIEW.replace(':type', type))
            .then((response) => {
                setMemoAr(response.data.memoAr);
                setMemoItemAr(response.data.memoItemAr);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [currentUser, type]);

    return (
        <div className="col-12 col-lg-9">
            <div className="user-order">
                <UserReviewTitleBar type={type} />

                {memoItemAr?.length !== 0 ? (
                    memoAr &&
                    memoAr?.map((item) => {
                        const memoItem = Object.values(memoItemAr)?.filter(
                            (mItem) => mItem.memoId.toString() === item.id.toString()
                        );

                        if (memoItem.length === 0) {
                            return null;
                        }
                        return (
                            <div className="user-order-section" key={item.id}>
                                <div>
                                    {type === 'pending' ? (
                                        <UserReviewSection
                                            memoData={item}
                                            memoItemData={memoItem}
                                            products={products}
                                        />
                                    ) : (
                                        <UserReviewSectionComplete
                                            memoData={item}
                                            memoItemData={memoItem}
                                            products={products}
                                        />
                                    )}
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="order-section-no-order">
                        <div className="order-section-no-order-title">
                            <h5>There Are No Reviews .</h5>
                            <h6>You can review and track your orders here.</h6>
                        </div>
                        <div className="order-section-no-order-img">
                            <img src={NoProductImg} alt="No Product" />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default UserReviewPage;
